import React, { Fragment } from "react";

import img13 from "../../../images/service/Centralized Crypto Exchange Development/1.png";
import img14 from "../../../images/service/Centralized Crypto Exchange Development/2.png";
import img15 from "../../../images/service/Centralized Crypto Exchange Development/3.png";

import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import TheorySection from "../../../components/PageSection/Theory";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";

// --------------------------------------------------
// DATA
// --------------------------------------------------

const serviceCards = [
  {
    icon: sIcon1,
    title: "Centralized Exchange Architecture",
    content:
      "High-performance centralized exchange systems with real-time order matching and liquidity management.",
  },
  {
    icon: sIcon2,
    title: "Trading Engine Development",
    content:
      "Ultra-fast matching engines capable of handling millions of trades per second.",
  },
  {
    icon: sIcon3,
    title: "Wallet & Fund Management",
    content:
      "Secure hot and cold wallet infrastructure with multi-signature protection.",
  },
];

const benefits = [
  {
    title: "High Liquidity",
    description:
      "Centralized order books ensure deep liquidity and tight spreads.",
    icon: sIcon1,
  },
  {
    title: "Fast Trade Execution",
    description:
      "Instant order matching with minimal latency.",
    icon: sIcon2,
  },
  {
    title: "User-Friendly Experience",
    description:
      "Intuitive interfaces suitable for beginners and professional traders.",
    icon: sIcon3,
  },
  {
    title: "Advanced Security",
    description:
      "Enterprise-grade security protocols protect user funds and data.",
    icon: sIcon4,
  },
  {
    title: "Regulatory Compliance",
    description:
      "Built-in KYC & AML workflows for legal compliance.",
    icon: sIcon5,
  },
  {
    title: "Scalable Infrastructure",
    description:
      "Designed to support rapid user and volume growth.",
    icon: sIcon6,
  },
];

const faqs = [
  {
    q: "What is a centralized crypto exchange?",
    a: "A centralized exchange is a platform operated by a central authority that facilitates crypto trading and manages user funds.",
  },
  {
    q: "Are centralized exchanges secure?",
    a: "Yes. With proper security architecture, centralized exchanges can offer robust protection for user assets.",
  },
  {
    q: "Can centralized exchanges support fiat trading?",
    a: "Yes. Centralized exchanges commonly support crypto-to-fiat trading pairs.",
  },
  {
    q: "Do you provide exchange maintenance?",
    a: "Yes. We offer ongoing maintenance, upgrades, and security monitoring.",
  },
];

// --------------------------------------------------
// PAGE COMPONENT
// --------------------------------------------------

export default function CentralizedCryptoExchangeDevelopment() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Centralized Crypto Exchange Development"
        pagesub="High-performance trading platforms with enterprise security"
      />

      {/* ================= HERO ================= */}
      <HeroSection
        title={
          <>
            Build a Robust{" "}
            <span className="gradient-text">Centralized Crypto Exchange</span>
          </>
        }
        subtitle={`Centralized exchanges power global crypto trading with speed,
liquidity, and reliability. We help businesses build secure, scalable,
and regulation-ready centralized crypto exchange platforms.`}
        buttonText="Build Centralized Exchange"
        buttonLink="/contact"
        image={img13}
        imageAlt="Centralized Crypto Exchange Development"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="What Is Centralized Crypto Exchange Development?"
        image={img14}
        paragraphs={[
          "Centralized crypto exchange development involves building trading platforms managed by a central authority that oversees user accounts, funds, and transactions. These exchanges provide high liquidity, fast execution, and advanced trading tools for users.",
          "By maintaining centralized control, these platforms can deliver superior performance, simplified user onboarding, and seamless fiat integrations, making them ideal for large-scale crypto trading operations.",
        ]}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Why Centralized Exchanges Dominate Trading Volume"
        image={img15}
        paragraphs={[
          "Centralized exchanges remain the backbone of the crypto trading ecosystem due to their deep liquidity, reliable infrastructure, and user-friendly interfaces. They are capable of handling high-frequency trading and institutional participation.",
          "For businesses, centralized exchanges offer monetization opportunities through trading fees, listings, and premium services while maintaining regulatory compliance and operational control.",
        ]}
      />

      {/* ================= SERVICES ================= */}
      <ServiceCardsSection
        title="Our Centralized Exchange Development Services"
        cards={serviceCards}
      />

      {/* ================= BENEFITS ================= */}
      <Benefit
        title="Benefits of Centralized Crypto Exchange Development"
        benefits={benefits}
      />

      {/* ================= KEY FEATURES ================= */}
      <KeyFeaturesSection
        title="Key Features of Centralized Exchanges"
        subtitle="Engineered for performance, security, and scale."
        features={[
          {
            icon: sIcon1,
            title: "High-Speed Matching Engine",
            description:
              "Low-latency trade execution with real-time order books.",
          },
          {
            icon: sIcon2,
            title: "Liquidity Management",
            description:
              "Deep liquidity through internal and external sources.",
          },
          {
            icon: sIcon3,
            title: "Secure Wallet Infrastructure",
            description:
              "Hot & cold wallet systems with multi-layer security.",
          },
          {
            icon: sIcon4,
            title: "Advanced Admin Controls",
            description:
              "Comprehensive admin dashboards for platform management.",
          },
          {
            icon: sIcon5,
            title: "KYC & AML Compliance",
            description:
              "Regulation-ready user verification workflows.",
          },
          {
            icon: sIcon6,
            title: "Scalable Cloud Architecture",
            description:
              "Built to handle large trading volumes and traffic spikes.",
          },
        ]}
      />

      {/* ================= WHY CHOOSE US ================= */}
      <WhyChooseUsSection
        items={[
          "Enterprise Exchange Development Expertise",
          "High-Performance Trading Infrastructure",
          "End-to-End Exchange Lifecycle Support",
        ]}
      />

      {/* ================= FAQ ================= */}
      <FaqSection faqs={faqs} />

      {/* ================= CTA ================= */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}

